// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.CreatePlaidLinkTokenWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { CreatePlaidLinkTokenWebApiHandler_createPlaidLinkToken } from '@zg-rentals/ts-rent-payment-client';

import type {
  CreatePlaidLinkTokenWebApiRequestDto,
  CreatePlaidLinkTokenWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export interface CreatePlaidLinkTokenWebApiHandler_createPlaidLinkToken_Args {
  postData: CreatePlaidLinkTokenWebApiRequestDto;
}

export type CreatePlaidLinkTokenWebApiHandler_createPlaidLinkToken_Options = UseMutationOptions<
  CreatePlaidLinkTokenWebApiResponseDto,
  unknown,
  CreatePlaidLinkTokenWebApiHandler_createPlaidLinkToken_Args
>;

/**
 * create plaid link token
 */
export const useCreatePlaidLinkTokenWebApiHandler_createPlaidLinkToken = ({
  httpClient,
  ...options
}: Omit<CreatePlaidLinkTokenWebApiHandler_createPlaidLinkToken_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CreatePlaidLinkTokenWebApiHandler_createPlaidLinkToken_Args) =>
      CreatePlaidLinkTokenWebApiHandler_createPlaidLinkToken(args.postData, httpClient),
  });
};
